import { CSSTransition, SwitchTransition } from 'react-transition-group';

import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import { useMemo, useRef } from 'react';

import { motion } from 'framer-motion';

function App() {
  const {
    currentState,
    isVisible,
    currentMessage,
    messageAnimationTrigger,
    setDelay,
  } = useBroadcast();

  const { bg, bgColor, duration } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg, bgColor]);

  // контейнер с сообщением, нужен для скролинга текста сообщения в useScrollText
  const messagesRef = useRef(null);

  return (
    <div className="app-wrapper" style={{ background }}>
      <CSSTransition
        in={currentState !== null && isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
        nodeRef={messagesRef}
      >
        <motion.div
          initial={{
            maskPosition: '100% 100%',
            WebkitMaskPosition: '100% 100%',
          }}
          animate={{ maskPosition: '0% 100%', WebkitMaskPosition: '0% 100%' }}
          transition={{ duration: 1, delay: 0.5 + 0 }}
          className="titre-wrapper"
          ref={messagesRef}
        >
          <div className={'facts'}>Факты ПОЛЮСА</div>
          <div className="message-wrapper">
            <CSSTransition
              in={currentMessage && currentState !== null}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit
            >
              <SwitchTransition>
                <CSSTransition
                  key={messageAnimationTrigger + currentState}
                  addEndListener={(node, done) => {
                    node.addEventListener('transitionend', done, false);
                  }}
                  classNames="fade"
                >
                  <Message
                    className="titre-message"
                    message={currentMessage?.message || {}}
                    setDelay={setDelay}
                    messagesWrapper={messagesRef.current}
                    duration={duration}
                  />
                </CSSTransition>
              </SwitchTransition>
            </CSSTransition>
          </div>
        </motion.div>
      </CSSTransition>
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
